import estat_50 from './50.png';
import estat_51 from './51.png';
import estat_52 from './52.png';
import estat_53 from './53.png';
import estat_54 from './54.png';
import estat_55 from './55.png';
import estat_56 from './56.png';
import estat_57 from './57.png';
import estat_58 from './58.png';
import estat_59 from './59.png';

export default {
    estat_50,
    estat_51,
    estat_52,
    estat_53,
    estat_54,
    estat_55,
    estat_56,
    estat_57,
    estat_58,
    estat_59
};


// WEBPACK FOOTER //
// ./src/images/mar/index.js